export var MobileVariant;
(function (MobileVariant) {
    MobileVariant[MobileVariant["NO_LINE"] = 0] = "NO_LINE";
    MobileVariant[MobileVariant["HORIZONTAL_LINE"] = 1] = "HORIZONTAL_LINE";
    MobileVariant[MobileVariant["VERTICAL_LINE"] = 2] = "VERTICAL_LINE";
    MobileVariant[MobileVariant["VERTICAL_LINE_COMPACT"] = 3] = "VERTICAL_LINE_COMPACT";
})(MobileVariant || (MobileVariant = {}));
export var StepperVariant;
(function (StepperVariant) {
    StepperVariant["DESKTOP"] = "DESKTOP";
    StepperVariant["MOBILE"] = "MOBILE";
    StepperVariant["DYNAMIC"] = "DYNAMIC";
})(StepperVariant || (StepperVariant = {}));
export var Brand;
(function (Brand) {
    Brand[Brand["STB"] = 0] = "STB";
    Brand[Brand["AKA"] = 1] = "AKA";
    Brand[Brand["COOP"] = 2] = "COOP";
    Brand[Brand["DANSKE_BANK"] = 3] = "DANSKE_BANK";
    Brand[Brand["DEFAULT"] = 4] = "DEFAULT";
    Brand[Brand["HUSEIERNE"] = 5] = "HUSEIERNE";
    Brand[Brand["SOFT_REBRAND"] = 6] = "SOFT_REBRAND";
})(Brand || (Brand = {}));
//# sourceMappingURL=index.js.map